document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const department = document.activeElement?.closest('.osenu-department-menu[open]');
  if (department) {
    department.open = false;
    department.querySelector('summary')?.focus({ preventScroll: true });
    return;
  }
  const menu = document.querySelector('.osenu-mobile-nav[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary')?.focus({ preventScroll: true });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.osenu-department-menu[open]').forEach((department) => {
    if (!department.contains(event.target)) department.open = false;
  });
  const menu = document.querySelector('.osenu-mobile-nav[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});
document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.osenu-department-menu[open]').forEach((department) => {
    if (!department.contains(event.target)) department.open = false;
  });
  const menu = document.querySelector('.osenu-mobile-nav[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});
window.matchMedia('(max-width: 749px)').addEventListener('change', (event) => {
  document.querySelectorAll('.osenu-department-menu[open]').forEach((department) => { department.open = false; });
  if (event.matches) return;
  const menu = document.querySelector('.osenu-mobile-nav[open]');
  if (menu) menu.open = false;
});
